import create from 'zustand'
import { devtools } from 'zustand/middleware'
import axios from 'axios';
import produce from 'immer';
import Cookies from 'js-cookie'

const useBackendCheckStore = create((set, get) => ({
    connected : false,

    setToConnected: () => {
        set({connected: true})
    },
    setToDisconnected: () => {
        set({connected: false})
    }
}))


export default useBackendCheckStore 